<div style="text-align:center;padding-top:10px" *ngIf="insurance.length == 0  && isBusy==false" translate>No Insurance data exists for student</div>
<div *ngIf="insurance.length > 0 ">
  <mat-table  matSort matSortDisableClear matSortActive="InsuranceCompany" [dataSource]="angularMatData" aria-label="Insurance Data Table">
    <ng-container matColumnDef="InsuranceCompany">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Company</span>
        <filter class="mat-filter" [data]="angularMatData" columnName="InsuranceCompany" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let ins">{{ins.InsuranceCompany}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Policy">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Policy</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="Policy" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let ins">{{ins.Policy}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="InsuranceStartDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Start Date</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="InsuranceStartDate" dataType="date"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let ins">
        <span *ngIf="ins.InsuranceStartDate != '0001-01-01T00:00:00'">{{ins.InsuranceStartDate|date:'MM/dd/yyyy'}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="InsuranceEndDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>End Date</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="InsuranceEndDate" dataType="date"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let ins">
        <span *ngIf="ins.InsuranceEndDate != '0001-01-01T00:00:00'">{{ins.InsuranceEndDate|date:'MM/dd/yyyy'}}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedInsuranceColumn"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedInsuranceColumn;" [attr.aria-label]="getInsuranceAriaRow(row)"></mat-row>
  </mat-table>
</div>
